import { render, staticRenderFns } from "./TestCase.vue?vue&type=template&id=5e59205c&scoped=true&"
import script from "./TestCase.vue?vue&type=script&lang=js&"
export * from "./TestCase.vue?vue&type=script&lang=js&"
import style0 from "./TestCase.vue?vue&type=style&index=0&id=5e59205c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e59205c",
  null
  
)

export default component.exports